import PremiumSimulatorResults from "./PremiumSimulatorResults";

export default PremiumSimulatorResults;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/premiumSimulator/results/index.js